<template>
  <!-- 报名详情--已通过 -->
  <div class="passedExam">
    <el-row class="tableHearInputBox" type="flex" justify="space-between">
      <el-col>
        <el-input
          v-model.trim="query.query"
          placeholder="请输入姓名"
          style="width: 200px"
          @keyup.enter.native="tableLoad"
          @clear="
            query.query = '';
            tableLoad();
          "
          clearable
          suffix-icon="el-icon-search"
        ></el-input>
        <Debounce>
          <el-button style="margin: 0px 10px" size="small" @click="tableLoad">查询</el-button>
        </Debounce>
        <el-select v-model="query.provinceId" filterable @change="frechLoad" placeholder="请选择">
          <el-option label="全部省份" value=""></el-option>
          <el-option v-for="item in proList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
        <el-select v-model="query.examSiteId" @change="frechLoad" filterable placeholder="请选择">
          <el-option label="全部市代" value=""></el-option>
          <el-option v-for="item in examSitList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
        <el-select v-model="query.registerId" @change="frechLoad" filterable placeholder="请选择">
          <el-option label="全部考点" value=""></el-option>
          <el-option
            v-for="item in rationSiteList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="query.paymentStatus"
          @change="frechLoad"
          filterable
          style="width: 120px"
          placeholder="请选择"
        >
          <el-option label="缴费状态" value=""></el-option>
          <el-option label="未缴费" value="0"></el-option>
          <el-option label="已缴费" value="1"></el-option>
        </el-select>
      </el-col>
      <Debounce>
        <el-button
          type="primary"
          v-if="$roleFilter('apply:server:batch:recall')"
          size="small"
          @click="operatInfo(3)"
          >撤回审核</el-button
        >
      </Debounce>
      <template v-if="offlinePayment === 1">
        <Debounce>
          <el-button
            type="primary"
            v-if="$roleFilter('apply:batch:recall:cancel:pay')"
            size="small"
            @click="operatInfo(4)"
            :disabled="buttonDisable"
            >取消缴费</el-button
          >
        </Debounce>
      </template>
      <Debounce>
        <el-button size="small" @click="exportExcel">导出</el-button>
      </Debounce>
    </el-row>
    <el-table
      :data="tableList"
      tooltip-effect="dark"
      border
      ref="elTable"
      @sort-change="sortChange"
      style="width: 100%"
      :header-cell-style="$store.getters.getTableHeadStyle"
      v-loading="tableIsLoad"
      element-loading-text="加载中"
      @selection-change="handleSelectionChange"
      :height="$store.getters.getTableHeight - 50"
    >
      <el-table-column align="center" type="selection"></el-table-column>
      <el-table-column prop="name" fixed="left" label="考生照片" width="80" align="center">
        <template slot-scope="scope">
          <img :src="scope.row.photo" style="height: 30px" @click="operatInfo(5, scope.row)" />
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        fixed="left"
        width="80"
        sortable="custom"
        label="姓名"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="surName"
        width="100"
        fixed="left"
        label="姓氏拼音"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="englishName"
        fixed="left"
        width="120"
        label="名字拼音"
        align="center"
      ></el-table-column>
      <el-table-column width="50" label="性别" align="center">
        <template slot-scope="scope">
          {{ scope.row.sex === 1 ? '男' : scope.row.sex === 2 ? '女' : '' }}
        </template>
      </el-table-column>
      <el-table-column prop="birth" label="出生日期" width="100" align="center"></el-table-column>
      <el-table-column prop="age" width="50" label="年龄" align="center"></el-table-column>
      <el-table-column prop="countryName" width="60" label="国籍" align="center"></el-table-column>
      <template>
        <el-table-column
          prop="idNumber"
          label="证件号码"
          width="170"
          align="center"
          sortable="custom"
        ></el-table-column>
      </template>
      <el-table-column prop="mobile" label="联系电话" width="120" align="center"></el-table-column>
      <el-table-column
        prop="address"
        label="快递地址"
        width="200"
        show-overflow-tooltip
        align="center"
      ></el-table-column>
      <el-table-column prop="provinceName" label="省份" width="70" align="center"></el-table-column>
      <el-table-column
        prop="examSiteName"
        label="市级代理"
        width="100"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="registrationPointName"
        show-overflow-tooltip
        label="考点"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="subjectAmount"
        label="应缴费用"
        width="80"
        align="center"
      ></el-table-column>
      <!-- <el-table-column label="缴费方式" width="80" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.paymentStatus === 1">
            {{ scope.row.paymentMethod == 1 ? "线上缴费" : "线下缴费" }}
          </span>
        </template>
      </el-table-column> -->
      <el-table-column label="报考等级" fixed="right" width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.testLevel | getLvTextByLv }}
        </template>
      </el-table-column>
      <el-table-column
        prop="zdjs"
        show-overflow-tooltip
        label="指导教师"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="zdjsdh"
        show-overflow-tooltip
        label="指导教师电话"
        align="center"
      ></el-table-column>
      <el-table-column label="上传证书" fixed="right" width="80" align="center">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.certificate"
            type="text"
            size="small"
            @click="operatInfo(2, scope.row)"
            >查看证书</el-button
          >
        </template>
      </el-table-column>
      <el-table-column label="缴费状态" width="80" fixed="right" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.paymentStatus === 1" class="notClick">已缴费</span>
          <span v-else-if="pays" class="notClick">未缴费</span>
          <span
            v-else
            @click="operatInfo(1, scope.row)"
            :class="scope.row.offlinePayment == 1 ? 'spanStyle' : 'notClick'"
            >未缴费</span
          >
        </template>
      </el-table-column>
      <el-table-column label="备注" width="120" fixed="right" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-input
            style="width: 96%"
            v-model="scope.row.bz"
            maxlength="50"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            v-if="status == scope.row.id"
            @keyup.enter.native="updateBz(scope.row.id, scope.row.bz)"
          ></el-input>
          <div v-else class="bzContent" @click="clickBz(scope.row)">{{ scope.row.bz }}</div>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      :total="query.total"
      :page.sync="query.pageNum"
      :limit.sync="query.pageSize"
      class="pagination-content"
      @pagination="tableLoad"
    />
    <el-dialog1
      custom-class="dailogComponents"
      title="人工缴费"
      :visible.sync="visible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      v-if="visible"
      width="500px"
    >
      <div class="dialogBox">
        <el-row type="flex" class="dialogTitle" justify="space-between">
          <el-col :span="10">
            <p><span style="color: red">*</span>请输入证件号码:</p>
          </el-col>
          <el-col :offset="1">
            <el-input v-model="idNumber" placeholder="请输入证件号码"></el-input>
          </el-col>
          <el-button style="margin-left: 20px" size="small" type="primary" @click="getUserInfo"
            >确认</el-button
          >
        </el-row>
        <div class="userInfoBox">
          <el-row type="flex">
            <div class="imgBox">
              <img :src="visibleObj.photo" alt="" />
            </div>
            <div class="userInfoTitle">
              <div class="userRow">
                <p>姓名：</p>
                <span>{{ this.visibleObj.name }}</span>
              </div>
              <div class="userRow">
                <p>性别：</p>
                <span>
                  {{
                    this.visibleObj.sex === 1 ? '男' : this.visibleObj.sex === 2 ? '女' : ''
                  }}</span
                >
              </div>
              <div class="userRow">
                <p>年龄：</p>
                <span>{{ this.visibleObj.age }}</span>
              </div>
              <div class="userRow">
                <p>国籍：</p>
                <span>{{ this.visibleObj.countryName }}</span>
              </div>
              <div class="userRow">
                <p>证件号码：</p>
                <span>{{ this.visibleObj.idNumber }}</span>
              </div>
              <div class="userRow">
                <p>联系电话：</p>
                <span>{{ this.visibleObj.mobile }}</span>
              </div>
            </div>
          </el-row>
          <div class="userInfoTableBox">
            <div class="infoTable">
              <div>考试科目</div>
              <div>{{ this.visibleObj.subjectName }}</div>
            </div>
            <div class="infoTable">
              <div>省份</div>
              <div>{{ this.visibleObj.provinceName }}</div>
            </div>
            <div class="infoTable">
              <div>考点</div>
              <div>{{ this.visibleObj.examSiteName }}</div>
            </div>
            <div class="infoTable">
              <div>报名点</div>
              <div>{{ this.visibleObj.registrationPointName }}</div>
            </div>
            <div class="infoTable">
              <div>报考等级</div>
              <div>{{ this.visibleObj.testLevel | getLvTextByLv }}</div>
            </div>
            <div class="infoTable">
              <div>证书</div>
              <div>
                <el-button
                  v-show="isSunmitType != 0 && visibleObj.certificate != ''"
                  size="medium"
                  @click="operatInfo(2, visibleObj)"
                  type="text"
                  >音基证书.jpg</el-button
                >
              </div>
            </div>
            <div class="infoTable">
              <div>应缴费用</div>
              <div>{{ this.visibleObj.subjectAmount }}</div>
            </div>
            <div class="infoTable">
              <div>缴费方式</div>
              <div>
                {{
                  this.visibleObj.paymentMethod == 1
                    ? '线上缴费'
                    : this.visibleObj.paymentMethod == 2
                    ? '线下缴费'
                    : ''
                }}
              </div>
            </div>
            <div class="infoTable">
              <div>缴费状态</div>
              <div
                :style="{
                  color: this.visibleObj.paymentStatus == 1 ? '#2d8cf0' : '#f56c6c',
                }"
              >
                {{
                  this.visibleObj.paymentStatus == 1
                    ? '已缴费'
                    : this.visibleObj.paymentStatus == 0
                    ? '未缴费'
                    : ''
                }}
              </div>
            </div>
          </div>
        </div>
        <el-row type="flex" class="dailogButBox" justify="center">
          <el-col :span="7">
            <el-button size="medium" @click="visible = false">取消</el-button>
          </el-col>
          <el-col :span="4">
            <el-button
              size="medium"
              type="primary"
              :disabled="isSunmitType != 1"
              @click="subCapture"
              >缴费</el-button
            >
          </el-col>
        </el-row>
      </div>
    </el-dialog1>
  </div>
</template>

<script>
import { exportFile } from '@/uitls/globalFun.js';
export default {
  props: ['infoId'],
  data() {
    return {
      buttonDisable: false,
      tableList: [],
      tableSelectList: [],
      tableIsLoad: true,
      proList: [], //省份考点下拉菜单
      rationSiteList: [], //报考等级下拉
      examSitList: [], //考点下拉菜单
      visible: false,
      visibleType: 0, //删除
      visibleObj: {
        photo: '', //头像
      },
      idNumber: '',
      isSunmitType: 0, //0为初始，1当前已经缴费或者无法缴费，2可以缴费
      query: {
        query: '',
        pageNum: 1, // 当前页
        pageSize: 15, // 每页显示条数
        total: 1, //总条数
        auditStatus: 1, //报名状态 1:已通过 2：待审核 0：未通过
        examInformationId: '', //考试信息ID
        examSiteId: '', //所属市级代理
        provinceId: '', //所属省份ID
        testLevel: '', //报考等级
        paymentStatus: '', //全部缴费状态0未缴费，1缴费
        registerId: '', //报名点id
        orderByChineseMethod: null, //姓名排序
        orderByChineseField: null, //姓名排序
      },
      offlinePayment: 0,
      pays: null,
      status: 0,
      optionParam: { id: null, bz: null },
    };
  },
  created() {
    this.query.examInformationId = this.infoId;
  },
  mounted() {
    this.pays = this.$route.query.pay;
    if (this.infoId == null) {
      return;
    }
    this.tableLoad();
    this.getSelectList();
  },
  methods: {
    getTableRole() {
      let { roleIdList, userName } = this.$store.getters.getUser;
      //如果账号为admin/学校管理员角色
      if (userName === 'admin' || (roleIdList && roleIdList.find((item) => item === '1'))) {
        return true;
      }
      return false;
    },
    updateBz(id, bz) {
      this.status = 0;
      this.$axios
        .post(`/apply/update`, {
          bz,
          id,
        })
        .then((res) => {
          this.$message({
            type: 'success',
            message: '修改成功!',
            duration: 1000,
          });
          this.tableLoad();
        });
    },
    clickBz (val) {
      if (!this.getTableRole()) return;
      if (this.status != 0 && this.optionParam.id != null) {
        this.tableList.forEach((item) => {
          if (item.id == this.optionParam.id) {
            item.bz = this.optionParam.bz;
          }
        });
      }
      this.optionParam = { id: val.id, bz: val.bz };
      this.status = val.id;
    },
    frechLoad() {
      this.query.pageNum = 1;
      this.tableLoad();
    },
    //列表排序改变事件
    sortChange(column) {
      if (column != null && column.order != null) {
        this.query.orderByMethod = column.order === 'ascending' ? 'asc' : 'desc';
        this.query.orderByField = column.prop === 'idNumber' ? 'id_number' : column.prop;
        console.log(column);
        if (column.prop === 'name') {
          this.query.orderByMethod = null;
          this.query.orderByField = null;
          this.query.orderByChineseMethod =
            column.order === 'ascending'
              ? 'asc'
              : column.order === 'ascending'
              ? 'descending'
              : 'desc';
          this.query.orderByChineseField = column.prop;
        } else {
          this.query.orderByChineseMethod = null;
          this.query.orderByChineseField = null;
        }
      } else {
        this.query.orderByMethod = null;
        this.query.orderByField = null;
        this.query.orderByChineseMethod = null;
        this.query.orderByChineseField = null;
      }
      this.tableLoad();
    },
    //导出
    exportExcel() {
      this.$axios.post('/apply/export', this.query, { responseType: 'blob' }).then((res) => {
        exportFile(res);
      });
    },
    tableLoad() {
      this.tableIsLoad = true;
      this.$axios.post('/apply/details/list', this.query).then((res) => {
        console.log(res);
        let { list, total } = res.data.data;
        this.tableList = list;
        this.offlinePayment = list[0] ? list[0].offlinePayment : 0;
        this.query.total = total;
        this.tableIsLoad = false;
      });
    },
    handleSelectionChange(val) {
      var flag = true;
      this.tableSelectList = val;
      this.tableSelectList.map((item) => {
        if (item.offlinePayment == 0) {
          this.buttonDisable = true;
          flag = false;
        }
      });
      if (flag) {
        this.buttonDisable = false;
      }
    },
    // 全部下拉菜单
    getSelectList() {
      this.$axios.get('/apply/newProvince').then((res) => {
        let data = res.data.data;
        this.proList = data;
      });
      this.$axios.get('/apply/examinationSite').then((res) => {
        let data = res.data.data;
        this.examSitList = data;
      });
      this.$axios.get('/apply/rationSite').then((res) => {
        let data = res.data.data;
        this.rationSiteList = data;
      });
    },
    // getRegList() {
    //   this.$axios.get(`/process/register/${this.query.examSiteId}`).then((res) => {
    //     let data = res.data.data;
    //     this.rationSiteList = data;
    //   });
    // },
    operatInfo(type, row) {
      this.visibleType = type;
      if (type === 1) {
        //判断是否置灰
        if (row.offlinePayment == 0) {
          return;
        }
        //人工缴费
        this.$dailog({
          title: '缴费',
          context: '是否进行缴费？',
          okButText: '缴费',
          callbackFun: () => {
            this.$axios.post(`apply/artificial/capture/${row.id}`).then((res) => {
              this.$message({
                type: 'success',
                message: '缴费成功!',
                duration: 1000,
              });
              this.tableLoad();
            });
          },
        });
      } else if (type == 2) {
        window.open(row.certificate, '查看证书');
      } else if (type == 3) {
        // 撤回审核
        if (this.tableSelectList.length == 0) {
          this.$message({
            type: 'warning',
            message: '请选择数据进行操作!',
            duration: 1000,
          });
          return;
        }
        let ids = [];
        this.tableSelectList.map((item) => {
          ids.push(item.id);
          return item;
        });
        this.$dailog({
          title: '撤回审核',
          context: '是否撤回已选考生的审核？',
          callbackFun: () => {
            this.$axios.put(`apply/batch/recall`, ids).then((res) => {
              this.$message({
                type: 'success',
                message: '已撤回!',
                duration: 1000,
              });
              this.tableLoad();
            });
          },
        });
      } else if (type == 4) {
        // 取消缴费
        if (this.tableSelectList.length == 0) {
          this.$message({
            type: 'warning',
            message: '请选择数据进行操作!',
            duration: 1000,
          });
          return;
        }
        let ids = [];
        let states = [];
        this.tableSelectList.map((item) => {
          ids.push(item.id);
          states.push(item.paymentStatus);
          return item;
        });
        //包含未缴费
        if (states.includes(0)) {
          this.$message({
            type: 'warning',
            message: '请勾选已缴费的考生!',
            duration: 1000,
          });
        } else {
          this.$dailog({
            title: '取消缴费',
            context: '将已选考生的缴费状态改为“未缴费”？',
            callbackFun: () => {
              this.$axios.put(`apply/batch/cancel/pay`, ids).then((res) => {
                this.$message({
                  type: 'success',
                  message: '已取消!',
                  duration: 1000,
                });
                this.tableLoad();
              });
            },
          });
        }
      } else if (type == 5) {
        this.$alert(`<img src="${row.photo}" style="width:100%;max-height:700px;" />`, '图片查看', {
          dangerouslyUseHTMLString: true,
          showConfirmButton: false,
          closeOnClickModal: true,
        });
      }
    },
    submit() {
      let { userName, name, mobile, userId, passWord } = this.visibleObj;
      if (userName === '' || name === '' || mobile === '' || passWord === '') {
        this.$message({
          type: 'warning',
          message: '必填项不能为空!',
          duration: 1000,
        });
        return;
      }
      let subType = this.visibleType === 1 ? 'post' : 'put';
      this.$axios({
        method: subType,
        url: '/judge',
        data: this.visibleObj,
      }).then((res) => {
        this.$message({
          type: 'success',
          message: '保存成功!',
          duration: 1000,
        });
        this.visible = false;
        this.tableLoad();
      });
    },
    proChange(val) {
      // this.query.examSiteId = "";
      // if (val == "") {
      //   this.examSitList = [];
      // } else {
      //   let proObj = this.proList.find((item) => {
      //     return item.provinceId === val;
      //   });
      //   this.examSitList = proObj.examSiteVOS;
      // }
      this.tableLoad();
    },
    examChange(val) {
      // this.rationSiteList = [];
      // this.query.registerId = '';
      // if (val) {
      //   this.getRegList();
      // }
      this.tableLoad();
    },
    getUserInfo() {
      let regTest = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/; //身份证正则
      if (!regTest.test(this.idNumber)) {
        this.$message.warning({
          message: '请填写正确证件号码码！',
          duration: 1000,
        });
        return;
      }
      this.$axios.get(`/apply/details/${this.infoId}/${this.idNumber}`).then((res) => {
        let { data, code } = res.data;
        this.$message.success({
          message: '查询成功!',
          duration: 1000,
        });
        if (code === 10000) {
          this.isSunmit = 2;
          this.isSunmitType = data.paymentStatus == 1 ? 2 : 1;
          this.visibleObj = data;
        }
      });
    },
    subCapture() {
      this.$axios.post(`/apply/artificial/capture/${this.visibleObj.id}`).then((res) => {
        let { data, code } = res.data;
        this.$message.success({
          message: '缴费成功!',
          duration: 1000,
        });
        this.visible = false;
        this.tableLoad();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.passedExam {
  .tableHearInputBox {
    .el-select {
      width: 200px;
      margin-right: 10px;
    }
  }

  .spanStyle {
    color: #f56c6c;
    text-decoration: underline;
    cursor: pointer;
  }

  .notClick {
    // pointer-events: none;
    color: gray;
    cursor: pointer;
  }

  .userInfoBox {
    padding: 10px;
    border: 1px solid #f2f2f2;
    margin-bottom: 10px;

    .imgBox {
      width: 100px;
      height: 140px;
      margin-left: 10px;

      img {
        height: 100%;
      }
    }

    .userInfoTitle {
      padding-left: 20px;

      .userRow {
        display: flex;
        line-height: 1.5;
        text-align: left;

        p {
          font-weight: bold;
          width: 80px;
        }

        span {
          font-size: 12px;
        }
      }
    }

    .userInfoTableBox {
      .infoTable {
        display: flex;
        line-height: 2;
        text-align: center;
        border: 1px solid #ccc;
        border-top: none;

        div:first-child {
          font-weight: bold;
          background-color: #f2f2f2;
          width: 100px;
          border-right: 1px solid #ccc;
        }

        div:last-child {
          flex: 1;
        }

        div:last-child:hover {
          background-color: #a0cfff;
        }
      }

      .infoTable:first-child {
        border-top: 1px solid #ccc;
        margin-top: 10px;
      }
    }
  }
}
// :v-deep .el-table--border .is-scrolling-right+.el-table__fixed-right {
//     padding-left: 1px;
// }
.bzContent {
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  white-space: nowrap; /* 不换行 */
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 省略号 */
}
::v-deep .el-table--border td {
  border-right: 2px solid #ebeef5 !important;
}
::v-deep .el-table {
  .el-table__fixed-body-wrapper {
    border: 0;
  }
}
</style>
